import React from "react";
import { Trash2 } from "lucide-react";

export default function MessagesTable({ messages, onDelete }) {
  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-muted/60 text-left">
            <tr>
              <th className="p-4 font-medium">Tanggal</th>
              <th className="p-4 font-medium">Nama</th>
              <th className="p-4 font-medium">Email</th>
              <th className="p-4 font-medium">Subjek</th>
              <th className="p-4 font-medium">Pesan</th>
              <th className="p-4"></th>
            </tr>
          </thead>
          <tbody>
            {messages.length === 0 && (
              <tr><td colSpan="6" className="p-10 text-center text-muted-foreground">Belum ada pesan.</td></tr>
            )}
            {messages.map((m) => (
              <tr key={m.id} className="border-t border-border" data-testid={`message-row-${m.id}`}>
                <td className="p-4 text-muted-foreground">{new Date(m.created_at).toLocaleDateString("id-ID")}</td>
                <td className="p-4 font-medium">{m.name}</td>
                <td className="p-4"><a href={`mailto:${m.email}`} className="text-primary hover:text-accent">{m.email}</a></td>
                <td className="p-4">{m.subject || "—"}</td>
                <td className="p-4 max-w-md text-muted-foreground">{m.message}</td>
                <td className="p-4">
                  <button onClick={() => onDelete(m.id)} className="text-destructive hover:bg-destructive/10 p-2 rounded" data-testid={`delete-msg-${m.id}`}>
                    <Trash2 className="h-4 w-4" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
